export default "/images/arrow-right-square.svg?37ab42c9f22eec9d6d935bfabcb73f11";